//import firebase from 'firebase';
import { collection, addDoc } from 'firebase/firestore/lite';
import db from '../components/Firebase/index';

// Secured Combined Catches
import { HandleExceptionWithSecureCatch } from "./CombinedCatch";

const addUserData = (promise) => {

    return async () => {

//        try {

            const data = await addDoc(promise.ref,promise.userData);
        ;
  /*      } catch(e) {
            dispatch(HandleExceptionWithSecureCatch(e));
            dispatch({
                type: "GET_COVID_DATA",
                payload: e.response.data
            })  
        }*/
    }
}

export default addUserData;